export const sortByPosition = array => {
  return array?.sort((a, b) => (a.position < b.position ? -1 : 1));
};
